import { useQuery } from '@tanstack/react-query';
import { EntityGroup } from '../containers/Entity/DrawerEntityGroups';
import { fetchAPI } from '../utils/api';
import { message } from 'antd';
import { FIVE_MINUTES } from '../constants/CONSTANTS';
import { sortBy } from 'lodash';

export const useAllEntityGroups = () => {
  const entityGroups = useQuery<{
    list: EntityGroup[];
    loading: boolean;
  }>(
    ['all-entity-groups'],
    async () => {
      const getEntityGroups = async (page = 1, prevs = []) => {
        const resp = await fetchAPI('entity/group', {
          payload: {
            page,
            per_page: 30,
          },
        });

        const all = [...prevs, ...resp.items];
        if (resp.total > resp.page * resp.per_page) {
          return getEntityGroups(page + 1, all);
        }

        return all as EntityGroup[];
      };

      try {
        const list = await getEntityGroups();

        return { loading: false, list: sortBy(list, 'name') };
      } catch (error) {
        message.error('Failed get all entity groups');
        return {
          list: [],
          loading: false,
        };
      }
    },
    {
      staleTime: FIVE_MINUTES,
      placeholderData: {
        loading: true,
        list: [],
      },
    }
  );

  return entityGroups;
};

export const useAllEntities = () => {
  const entities = useQuery<{
    list: { id: number; name: string }[];
    loading: boolean;
  }>(
    ['all-entities'],
    async () => {
      const getEntities = async (page = 1, prevs = []) => {
        const resp = await fetchAPI('entity/list-for-filter', {
          method: 'POST',
          payload: {
            page,
            per_page: 100,
          },
        });

        const all = [...prevs, ...resp.items];
        if (resp.total > resp.page * resp.per_page) {
          return getEntities(page + 1, all);
        }

        return all;
      };

      try {
        const list = await getEntities();

        return { loading: false, list: sortBy(list, 'name') };
      } catch (error) {
        message.error('Failed get all entities');
        return {
          list: [],
          loading: false,
        };
      }
    },
    {
      staleTime: FIVE_MINUTES,
      placeholderData: {
        loading: true,
        list: [],
      },
    }
  );

  return entities;
};
